module.exports = __webpack_public_path__ + "static/img/itchio_icon.6f37885.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itchio_icon.png
// module id = MV/c
// module chunks = 0